import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-tj-basic-input',
  templateUrl: './tj-basic-input.component.html',
  styleUrls: ['./tj-basic-input.component.css']
})
export class TjBasicInputComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  @Input() label: string;
  @Input() placeholder: string = "";
  @Input() disabled: boolean = false;
}
